import React, { useState, useEffect } from 'react';

function Loading() {
  const [dots, setDots] = useState('.');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevDots => (prevDots.length < 3 ? prevDots + '.' : '.'));
    }, 500); // 500ms 간격으로 점 추가

    return () => clearInterval(interval); // 정리
  }, []); // 빈 배열을 유지하여 최초 1회만 실행

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <p>Loading {dots}</p>
    </div>
  );
}

export default Loading;
